<template>
	<div class="d-flex justify-content-between align-items-center select-addres">
		<div @click="pickAddress('strat')">
			<span class="select-down clearfix start">
       	 始发地
        <i class="fa fa-caret-down"></i>
     </span>
			<h4>{{pickers.startName}}</h4>
		</div>
		<div>
			<img src="@/assets/imgs/icons/car.png" alt>
		</div>
		<div @click="pickAddress('end')">
			<span class="select-down clearfix end">
       	 目的地
        <i class="fa fa-caret-down"></i>
      </span>
			<h4>{{pickers.endName}}</h4>
		</div>
		<cityPick @emitCity="emitCity" v-if="showPickCity"></cityPick>
	</div>
</template>
<script>
	import { CITY } from "@/assets/configs"
	export default {
		data() {
			return {
				showPickCity:false,
				direction:null,
				pickers: {
					startName: null,
					endName: null
				}
			}
		},
		methods : {
			pickAddress (direction) {
				this.direction = direction
				this.showPickCity = true
			},
			emitCity (data) {
				if(this.direction == "strat"){
					this.pickers.startName = data.cityText
				}else if(data.direction == "end"){
					this.pickers.endName = data.cityText
				}
				this.showPickCity = false
			}
		},
		mounted () {
			
		}
	}
</script>

<style lang="scss" scoped>
	.select-addres {
		.select-down {
			display: flex;
			justify-content: center;
			align-items: center;
			color: #9b9b9b;
			font-size: 0.36rem;
			.fa {
				font-size: 0.6rem;
				margin-left: 0.2rem;
				margin-top: 0.1rem;
			}
			&.start {
				.fa {
					color: #5989d6;
				}
			}
			&.end {
				.fa {
					color: #ff6600;
				}
			}
			&+h4 {
				width:3rem;
				white-space: nowrap;
				text-overflow: ellipsis;
				overflow: hidden;
				font-weight: bold;
				font-size: 0.4rem !important;
				padding-top: 0.1rem;
				text-align: center;
			}
		}
	}
	.popup-addre {
		width: 100vw;
	}
	.picker-btn-wrap {
		padding: .2rem .5rem;
		font-size: .4rem;
		color: blue;
	}
</style>